<template>
  <BotIcon
    name="helpCircle_line"
    size="16"
    :padding="0"
    style="color: var(--text-neutral-color-text-quaternary)"
  />
</template>
